import React from "react";

import { useAppSelector } from "../../../../../redux/hooks";
import Text from "../../../../../styleguide/Text";
import ContentCard from "../../../../../components/misc/ContentCard";
import { firstLetterToUpperCase } from "../../../../../helpers/stringFormater";

function VerifyCommandHeader() {
  const {
    picking: {
      verifyCommand: { verificationZone },
      verifyCommandProducts: {
        data: verifyCommandProductsData,
        isLoading: isLoadingVerifyCommandProducts,
      },
    },
  } = useAppSelector((state) => ({
    picking: state.picking,
  }));

  const productData = verifyCommandProductsData.list[0];

  return (
    <ContentCard
      className="text-center"
      cardBodyClassName="!overflow-visible"
      isLoading={isLoadingVerifyCommandProducts}>
      <div className="grid grid-cols-1 gap-x-6 gap-y-4 text-center sm:grid-cols-2 lg:grid-cols-3">
        <div>
          <Text variant="body1">Colectat de</Text>
          <Text variant="h3">
            {firstLetterToUpperCase(verifyCommandProductsData.userName)}
          </Text>
        </div>
        <div>
          <Text variant="body1">Zona verificare</Text>
          <Text variant="h3">{verificationZone}</Text>
        </div>
        <div>
          <Text variant="body1">
            Numar comanda / <span className="text-brand">Online</span>
          </Text>
          <Text variant="h3">
            {productData?.Op} /{" "}
            <span className="text-brand">{productData?.orderId}</span>
          </Text>
        </div>
        <div>
          <Text variant="body1">Cumparator</Text>
          <Text variant="h3">{verifyCommandProductsData.cumparator}</Text>
        </div>
        <div>
          <Text variant="body1">Ruta</Text>
          <Text variant="h3">{verifyCommandProductsData.ruta}</Text>
        </div>
        <div>
          <Text variant="body1">Punct de livrare</Text>
          <Text variant="h3">{verifyCommandProductsData.pctDeLivr}</Text>
        </div>
      </div>
    </ContentCard>
  );
}

export default VerifyCommandHeader;
